import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import AboutUs from "./sections/AboutUs";
import OurServices from "./sections/OurServices";
import OurGarages from "./sections/OurGarages";
import QuickContact from "./sections/QuickContact";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <Hero />
      <AboutUs />
      <OurServices />
      <OurGarages />
      <QuickContact />
      <Footer />
    </div>;
}